export var SWITCHER_LOOM_RECOMMENDATION_EXPERIMENT_KEY = 'switcher_loom_recommendation';
export var LOOM_PRODUCT_ID = 'loom';
export var LOOM_SWITCHER_EXP_SOURCE_COMPONENT = 'switcher-loom-exp';